import styled from '@emotion/styled';
import LeftArrow from '../../../../../components/Icon/left-arrow.svg';

export default styled(LeftArrow)({
    alignSelf: 'center',
    gridArea: 'icon',
    height: '16px',
    width: '10px'
});
